/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import InformationSharingComparisonChart from './components/informationSharingComparisonChart';
import IntroSection from './components/introSection';
import LegalLinks from '../../components/legalLinks';
import NltcInformationSharingComparisonChart from './components/nltcInformationSharingComparisonChart';
import NltcQuestionsAndInfoSection from './components/nltcQuestionsAndInfoSection';
import NltcSection from './components/nltcSection';
import NmisInformationSharingComparisonChart from './components/nmisInformationSharingComparisonChart';
import NmisQuestionsAndInfoSection from './components/nmisQuestionsAndInfoSection';
import NmisSection from './components/nmisSection';
import QuestionsAndInfoSection from './components/questionsAndInfoSection';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      disableDisclaimerTopBorder
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Customer Privacy Notice',
          linkUrl: '/customer-privacy-notice/',
          linkAriaLabel: 'Northwestern Mutual Customer Privacy Notice',
        },
      ]}
    >

      {/* INTRO SECTION */}
      <IntroSection />

      {/* INFORMATION SHARING COMPARISON CHART */}
      <InformationSharingComparisonChart />

      {/* QUESTIONS AND INFO SECTION */}
      <QuestionsAndInfoSection />

      {/* NLTC SECTION */}
      <NltcSection />

      {/* NLTC INFORMATION SHARING COMPARISON CHART */}
      <NltcInformationSharingComparisonChart />

      {/* NLTC QUESTIONS AND INFO SECTION */}
      <NltcQuestionsAndInfoSection />

      {/* NMIS SECTION */}
      <NmisSection />

      {/* NMIS INFORMATION SHARING COMPARISON CHART */}
      <NmisInformationSharingComparisonChart />

      {/* NMIS QUESTIONS AND INFO SECTION */}
      <NmisQuestionsAndInfoSection />

      {/* LEGAL LINKS */}
      <LegalLinks />
    </Page>
  );
};
